/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Celerity.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateUserRequest,
  CurrentUserDTO,
  SearchRequest,
  SearchResultOfUserDetailsDTO,
  UpdateUserRequest,
  UserDTO,
  UserDetailsDTO
} from '../model';

import { apiRequest } from '../../client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Create a new user.
 * @summary Create User.
 */
export const createUser = (
    createUserRequest: CreateUserRequest,
 options?: SecondParameter<typeof apiRequest<UserDTO>>,) => {
      return apiRequest<UserDTO>(
      {url: `/idm/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserRequest
    },
      options);
    }
  /**
 * Get the currently authenticated user.
 * @summary Get Current User.
 */
export const getCurrentUser = (

 options?: SecondParameter<typeof apiRequest<CurrentUserDTO>>,) => {
      return apiRequest<CurrentUserDTO>(
      {url: `/idm/users`, method: 'GET'
    },
      options);
    }
  /**
 * Update a user.
 * @summary Update User.
 */
export const updateUser = (
    updateUserRequest: UpdateUserRequest,
 options?: SecondParameter<typeof apiRequest<UserDTO>>,) => {
      return apiRequest<UserDTO>(
      {url: `/idm/users`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserRequest
    },
      options);
    }
  /**
 * Search for users.
 * @summary Search Users.
 */
export const searchUsers = (
    searchRequest: SearchRequest,
 options?: SecondParameter<typeof apiRequest<UserDTO[]>>,) => {
      return apiRequest<UserDTO[]>(
      {url: `/idm/users/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchRequest
    },
      options);
    }
  /**
 * Search for users as an admin.
 * @summary Search Users Admin.
 */
export const searchUsersAdmin = (
    searchRequest: SearchRequest,
 options?: SecondParameter<typeof apiRequest<SearchResultOfUserDetailsDTO>>,) => {
      return apiRequest<SearchResultOfUserDetailsDTO>(
      {url: `/idm/users/search/admin`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchRequest
    },
      options);
    }
  /**
 * Update the current user's currently selected organization partner.
 * @summary Update Current Partner.
 */
export const updateUserCurrentPartner = (
    partnerID: string,
 options?: SecondParameter<typeof apiRequest<CurrentUserDTO>>,) => {
      return apiRequest<CurrentUserDTO>(
      {url: `/idm/users/partner/${partnerID}`, method: 'PUT'
    },
      options);
    }
  /**
 * Update the organization the current user is viewing the application as. Super Admin only.
 * Selecting the user's own organization clears the override.
 * @summary Update Current Organization.
 */
export const updateUserCurrentOrganization = (
    organizationID: string,
 options?: SecondParameter<typeof apiRequest<CurrentUserDTO>>,) => {
      return apiRequest<CurrentUserDTO>(
      {url: `/idm/users/organization/${organizationID}`, method: 'PUT'
    },
      options);
    }
  /**
 * Turn on status page update emails for the current user (DEV-1676).
 * @summary Enable Status Page Emails.
 */
export const enableStatusPageEmails = (

 options?: SecondParameter<typeof apiRequest<CurrentUserDTO>>,) => {
      return apiRequest<CurrentUserDTO>(
      {url: `/idm/users/status-page-emails/enable`, method: 'PUT'
    },
      options);
    }
  /**
 * Turn off status page update emails for the current user (DEV-1676).
 * @summary Disable Status Page Emails.
 */
export const disableStatusPageEmails = (

 options?: SecondParameter<typeof apiRequest<CurrentUserDTO>>,) => {
      return apiRequest<CurrentUserDTO>(
      {url: `/idm/users/status-page-emails/disable`, method: 'PUT'
    },
      options);
    }
  /**
 * Update a user's role.
 * @summary Update User Role.
 */
export const updateUserRole = (
    userID: string,
    roleID: string,
 options?: SecondParameter<typeof apiRequest<UserDetailsDTO>>,) => {
      return apiRequest<UserDetailsDTO>(
      {url: `/idm/users/${userID}/role/${roleID}`, method: 'PUT'
    },
      options);
    }
  /**
 * Enable a user's account.
 * @summary Enable User.
 */
export const enableUser = (
    userID: string,
 options?: SecondParameter<typeof apiRequest<UserDTO>>,) => {
      return apiRequest<UserDTO>(
      {url: `/idm/users/${userID}/enable`, method: 'PUT'
    },
      options);
    }
  /**
 * Disable a user's account.
 * @summary Disable User.
 */
export const disableUser = (
    userID: string,
 options?: SecondParameter<typeof apiRequest<UserDTO>>,) => {
      return apiRequest<UserDTO>(
      {url: `/idm/users/${userID}/disable`, method: 'PUT'
    },
      options);
    }
  export type CreateUserResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
export type GetCurrentUserResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>
export type UpdateUserResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
export type SearchUsersResult = NonNullable<Awaited<ReturnType<typeof searchUsers>>>
export type SearchUsersAdminResult = NonNullable<Awaited<ReturnType<typeof searchUsersAdmin>>>
export type UpdateUserCurrentPartnerResult = NonNullable<Awaited<ReturnType<typeof updateUserCurrentPartner>>>
export type UpdateUserCurrentOrganizationResult = NonNullable<Awaited<ReturnType<typeof updateUserCurrentOrganization>>>
export type EnableStatusPageEmailsResult = NonNullable<Awaited<ReturnType<typeof enableStatusPageEmails>>>
export type DisableStatusPageEmailsResult = NonNullable<Awaited<ReturnType<typeof disableStatusPageEmails>>>
export type UpdateUserRoleResult = NonNullable<Awaited<ReturnType<typeof updateUserRole>>>
export type EnableUserResult = NonNullable<Awaited<ReturnType<typeof enableUser>>>
export type DisableUserResult = NonNullable<Awaited<ReturnType<typeof disableUser>>>
